module.exports = __webpack_public_path__ + "static/media/magnify-glass-icon-grey.431f9a8b.svg";